<template>
  <div id="page-provide-number-per-rolls-create">
    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between mb-md-4">
      <h5 class="">{{ $t('pages.qtyRolls.createQtyRoll') }}</h5>
      <div>
        <router-link
            class="btn btn-outline-primary mt-2 mt-md-0"
            :to="{ name: 'provide-number-per-rolls-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudProvideNumberPerRolls
        :provide-number-per-rolls="provideNumberPerRolls"
        :actionForm="'create'"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      provideNumberPerRolls: {}
    }
  },
  components : {
    FormCrudProvideNumberPerRolls: () => import('@/components/pages/provideNumberPerRolls/FormCrudProvideNumberPerRolls')
  }
}
</script>

<style scoped>

</style>
